const Direction = {
  COLUMN: "column",
  ROW: "row",
};

export default Direction;
